import format from 'date-fns/format'
import { FC } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import s from './AdSpotCard.module.scss'

import { AdSpot } from 'types/adspot'

import { getIconByMetaverse } from 'constants/MetaverseIcons'

import transformUTCToLocale from 'utils/transformUTCToLocale'

import { useShowDropdown } from 'hooks/useShowDropdown'

import { InfoIcon } from 'assets/icons/InfoIcon'

import { Card } from 'components/UI/Card/Card'
import { Dropmenu } from 'components/UI/Dropmenu/Dropmenu'
import { Status } from 'components/UI/Status/Status'

import { STATUS_NAME_BY_STATUS_VALUE, STATUS_STYLE_BY_STATUS_NUMBER } from 'pages/MyAdSpots/components/AdSpotCard'
import { createAdSpotStatus } from 'pages/MyAdSpots/helpers/createAdSpotStatus'

interface IAdSpotCard {
  adSpot: AdSpot
}

const AdSpotCard: FC<IAdSpotCard> = ({ adSpot }) => {
  const { ref, showDropdown } = useShowDropdown()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const openAdSpotInfoModal = () => {
    navigate(`${adSpot.id}/?${searchParams}`, { replace: true })
  }

  return (
    <Card variant="primary" onClick={openAdSpotInfoModal} className={s.card}>
      <Card.Image height='14.063rem'>
        <img src={adSpot?.preview_url} alt="Preview" />
        <img src={getIconByMetaverse(adSpot?.spot_type?.name)} alt="" className={s.metaLogo} />
        {/* <div className={`${s.status} ${s[STATUS_STYLE_BY_STATUS_NUMBER[createAdSpotStatus(adSpot?.last_activity)]]}`}>
          {STATUS_NAME_BY_STATUS_VALUE[createAdSpotStatus(adSpot?.last_activity)]}
        </div> */}
        <Status
          statusClassName={s.status}
          label={STATUS_NAME_BY_STATUS_VALUE[createAdSpotStatus(adSpot?.last_activity)]}
          color={STATUS_STYLE_BY_STATUS_NUMBER[createAdSpotStatus(adSpot?.last_activity)]}
        />
      </Card.Image>
      <Card.Info className={s.cardInfo}>
        <div className={s.footer}>
          <Card.CroppedText>{adSpot.name}</Card.CroppedText>
          <p className={s.footerDate}>{format(transformUTCToLocale(adSpot.created_at), 'dd.MM.yyyy HH:mm')}</p>
        </div>
        <Dropmenu
          variant="primary"
          show={showDropdown}
          cref={ref}
          items={[{ icon: <InfoIcon />, title: 'Show Info', onClick: openAdSpotInfoModal }]}
        />
      </Card.Info>
    </Card>
  )
}

export default AdSpotCard
